import { render } from "./loki.vue?vue&type=template&id=410aec32"
import script from "./loki.vue?vue&type=script&lang=js"
export * from "./loki.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__